import React from 'react';

import { link } from '@aline/routes';
import { Typography } from '@mui/material';
import type { GridRenderCellParams } from '@mui/x-data-grid-premium';
import { Link } from 'react-router-dom';
import { PartyAvatar } from 'src/components';
import type { Apollo } from 'src/gql/generated';
import { openLinkFromAnchorClick } from 'src/helpers';
import { createClampStyles } from 'src/theme';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  cell: {
    alignItems: 'center',
    display: 'flex',
    // Needed for ellipse to work on noWrap text.
    width: '100%',
  },
  nameLink: {
    alignItems: 'center',
    color: theme.appColors.iconsType,
    display: 'flex',
    flex: 1,
    textDecoration: 'none',
  },
  nameText: {
    ...createClampStyles(2),
    marginLeft: theme.spacing(1),
  },
}));

export type PartyNameRow = Pick<Apollo.Party, 'id' | 'name' | '__typename'>;

export function PartyNameCell<T extends PartyNameRow>({
  row,
  value,
}: GridRenderCellParams<T>): JSX.Element {
  const { classes } = useStyles();
  const partyHref = link.PartyDetailDocuments({ partyId: row.id });
  const title = value || 'Untitled Party';

  return (
    <div className={classes.cell}>
      <Link
        className={classes.nameLink}
        to={partyHref}
        onClick={e => openLinkFromAnchorClick(e, partyHref, { title })}
      >
        <PartyAvatar party={row} />
        <Typography noWrap className={classes.nameText}>
          {value || 'Untitled'}
        </Typography>
      </Link>
    </div>
  );
}
